import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AppComponent } from '../app.component';
import { SharedModule } from '../shared/modules/shared.module';
import { AuthGuard } from '../auth.guard';
import { RouterModule } from '@angular/router';

import { ListComponent } from './list/list.component';
import { BidLogComponent, BidLogParameterDialog } from './bid-log/bid.log.component';
import { LeadSourceComponent, LeadSourceParameterDialog } from './lead-source/lead.source.component';
import { CustomerSummaryComponent, CustomerSummaryParameterDialog } from './customer-summary/customer.summary.component';
import { LostQuoteComponent, LostQuoteParameterDialog } from './lost-quote/lost.quote.component';
import { routing } from './reports.routing';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ReportService } from './services/report.service';
import { DealerEngagementComponent, DealerEngagementParameterDialog } from './dealer-engagement/dealer.engagement.component';
import { DealerLicensureComponent } from './dealer-licensure/dealer-licensure.component';
import { ReportExportDialog } from './report-export-dialog/report.export.dialog';
import { JobCostComponent, JobCostParameterDialog } from './job-cost/job-cost.component';
import { PayrollSummaryComponent, PayrollSummaryParameterDialog } from './payroll-summary/payroll-summary.component';
import { EmailLogComponent, EmailLogParameterDialog } from './email-log/email.log.component';
import { DealerContactComponent, DealerContactParameterDialog } from './dealer-contact/dealer-contact.component';
import { CustomerMetricComponent, CustomerMetricParameterDialog } from './customer-metric/customer-metric.component';
import { InventoryComponent } from './inventory/inventory.component';
import { InventoryParameterDialog } from './inventory/inventory-parameter/inventory-parameter.dialog';
import { DealerLoginParameterDialog, DealersLatestLoginComponent } from './dealers-latest-login/dealers-latest-login.component';
import { MessageLogComponent, MessageLogParameterDialog } from './message-log/message.log.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule.forRoot(routing, {}),
        SharedModule,
    ],
    declarations: [ListComponent,
      BidLogComponent, BidLogParameterDialog,
      CustomerSummaryComponent, CustomerSummaryParameterDialog,
      CustomerMetricComponent, CustomerMetricParameterDialog,
      DealerEngagementComponent, DealerEngagementParameterDialog, DealerLicensureComponent,
      EmailLogComponent, EmailLogParameterDialog,
      JobCostComponent, JobCostParameterDialog,
      LeadSourceComponent, LeadSourceParameterDialog,
      LostQuoteComponent, LostQuoteParameterDialog,
      PayrollSummaryComponent, PayrollSummaryParameterDialog,
      ReportExportDialog,
      DealerContactComponent, DealerContactParameterDialog,
      InventoryComponent, InventoryParameterDialog,
      DealersLatestLoginComponent, DealerLoginParameterDialog,
      MessageLogComponent, MessageLogParameterDialog,
    ],
    exports: [],
    providers: [AppComponent, AuthGuard, ReportService]
})
export class ReportsModule { }
